import React from 'react';
import { X } from 'lucide-react';

const AssetSelector = ({ onSelect, onClose }) => {
  // Mock assets data
  const assets = [
    { id: 'AST001', name: 'AC Unit 1', type: 'HVAC', location: 'Main Floor' },
    { id: 'AST002', name: 'Refrigerator 1', type: 'Equipment', location: 'Kitchen' },
    { id: 'AST003', name: 'Lighting System', type: 'Electrical', location: 'Dining Area' },
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 max-w-2xl w-full mx-4">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold">Select Asset</h3>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg">
            <X className="w-5 h-5" />
          </button>
        </div>
        
        <div className="divide-y divide-gray-200">
          {assets.map((asset) => (
            <button
              key={asset.id}
              onClick={() => onSelect(asset)}
              className="w-full px-4 py-3 hover:bg-gray-50 flex items-center justify-between text-left"
            >
              <div>
                <h4 className="font-medium text-gray-900">{asset.name}</h4>
                <p className="text-sm text-gray-500">{asset.location}</p>
              </div>
              <span className="text-sm text-gray-600">{asset.type}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AssetSelector; 